// components
import Select from '@drivesally/sally-ui/lib/components/Select/Select';
import Text from '@drivesally/sally-ui/lib/components/Text/Text';

// local handlers
import selectOptionHandler from './handlers/selectOption.handler';

// local lib
import convertToOptions from './lib/convertToOptions.lib';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {useEffect, useState} from 'react';

// branch api
import listReducedDeductibleOptionsApi from '../../../branch/api/listReducedDeductibleOptions.api.branch';

// reducedDeductible lib
import generateReducedDeductibleKey from '../../lib/generateKey.lib.reducedDeductible';

// error
import parseError from '../../../error/parseError';

// lib
import {lib} from '@drivesally/sally-ui';
import fkOrId from '@drivesally/sally-fw/lib/lib/fkOrId';

// types
import {amount as amountType} from '@drivesally/sally-fn/lib/types';

const {alert} = lib;

const ReducedDeductibleOptionSelect = ({
  branch,
  disabled,
  label = 'Damage Waiver',
  onChange,
  readOnly = false,
  reducedDeductible,
  selectProps = {},
}) => {
  const [options, setOptions] = useState([]);
  const [optionsLoading, setOptionsLoading] = useState(false);

  const branchId = fkOrId(branch);

  useEffect(() => {
    if (readOnly) return undefined;

    if (!branchId) {
      setOptions([]);
      setOptionsLoading(false);
      return undefined;
    }

    let cancelled = false;
    setOptionsLoading(true);
    listReducedDeductibleOptionsApi({sally_branch: branchId})
      .then((results) => {
        if (!cancelled) {
          setOptions(Array.isArray(results) ? results : []);
          setOptionsLoading(false);
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setOptionsLoading(false);
          const {message} = parseError(error);
          alert.error(message);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [readOnly, branchId]);

  if (readOnly) {
    return (
      <Text
        value={
          !!reducedDeductible
            ? `Deductible: $${amountType(
                reducedDeductible?.deductible_amount || 0
              ).format()} Rate: $${amountType(
                reducedDeductible?.rate || 0
              ).format()}`
            : '-'
        }
        {...selectProps}
      >
        {label}
      </Text>
    );
  }

  return (
    <Select
      disabled={disabled || optionsLoading}
      notFilterable
      onChange={selectOptionHandler({options, onChange})}
      options={convertToOptions(options)}
      value={generateReducedDeductibleKey(reducedDeductible)}
      {...selectProps}
    >
      {label}
    </Select>
  );
};

ReducedDeductibleOptionSelect.propTypes = {
  branch: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  disabled: PropTypes.bool,
  label: PropTypes.node,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  reducedDeductible: PropTypes.object,
  selectProps: PropTypes.object,
};

export default ReducedDeductibleOptionSelect;
